// extracted by mini-css-extract-plugin
export default {"container":"FAQs--container--527bfc","header":"FAQs--header--33b99a","question":"FAQs--question--9ebb4f"};